import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const Footer = () => {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        {/* Top */}
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg text-background-50">汗汗漫画</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              汗汗漫画致力于为中文读者提供优质的韩国漫画在线阅读体验，
              流畅的下拉式阅读带来极致视觉享受，每日更新让你不再错过任何精彩。
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">漫画分类</h4>
            <ul className="grid grid-cols-2 gap-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/remen-tuijian" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  热门推荐
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                contact@hanhanmanhua.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-line"></i>
                </span>
                在线客服：工作日 9:00-18:00
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-5 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 汗汗漫画 HanHanManhua. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;